const sidebarWrapper = document.querySelector('.detailSummarySidebarAndNav');
const sidebar = document.querySelector<HTMLElement>('#detailSummarySidebarAndNav__sidebar');
const intersectingElems = document.querySelectorAll('.detailSummaryGroup__wrapper');

function formatHref(text: string): string {
	return text.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and');
}

function calculateVisibleHeightInViewport(elem: any) {
    const elemRect = elem.getBoundingClientRect();
    const vh = document.documentElement.clientHeight;
    if (elemRect.bottom < 0 || elemRect.top > vh) {
        return 0;
    }

    const bottom = Math.min(elemRect.bottom, vh);
    const top = Math.max(elemRect.top, 0);
    return bottom - top;
}

function checkVisibleElements() {
    let maxVisibleHeight = 0;
    let maxVisibleHeightElement: any = null;

    for (let i = 0; i < intersectingElems.length; i++) {
        let visibleHeight = calculateVisibleHeightInViewport(intersectingElems[i]);

        if (visibleHeight > maxVisibleHeight) {
            maxVisibleHeight = visibleHeight;
            maxVisibleHeightElement = intersectingElems[i];
        }
    }

    for (let i = 0; i < intersectingElems.length; i++) {
        if (maxVisibleHeightElement != intersectingElems[i]) {
            intersectingElems[i].classList.remove('start-animation');
            sidebarWrapper?.querySelectorAll('a').forEach((elem) => {
                if (maxVisibleHeightElement && elem.href.includes(maxVisibleHeightElement.id)) {
                    elem.classList.add('active')
                } else {
                    elem.classList.remove('active')
                }
            });
        }
    }

    if (maxVisibleHeightElement != null) {
        maxVisibleHeightElement.classList.add('start-animation');
    }
}

function buildNavigation() {
	if (!sidebar) {
		return;
	}
    intersectingElems.forEach(section => {
        const categoryName = section.getAttribute('data-detail-group-summary-category') as string;
        const headingName = section.querySelector('.detailSummaryGroup__heading')?.textContent;
		if (!headingName) {
			return;
		}
        const href = `#${formatHref(headingName)}`;
        const anchor = document.createElement('a');
        anchor.setAttribute('href', href);
        anchor.innerText = categoryName;
        const navItem = document.createElement('li');
        navItem.appendChild(anchor);
        sidebar.appendChild(navItem);
        sidebar.querySelector('a:first-child')?.classList.add('active');
    });
}

// Phone animation
function positionSidebar() {
	if (sidebar && sidebarWrapper) {
		const sidebarHeight = sidebar.getBoundingClientRect().height;
		const preferredPositionY = 20;
		const minY = sidebarWrapper.getBoundingClientRect().top + 20; /* needs to match the added padding */
		const maxY = sidebarWrapper.getBoundingClientRect().bottom - (sidebarHeight + 75);
		const positionY = Math.max(minY, Math.min(preferredPositionY, maxY));

		sidebar.classList.add('fixedNav');
		sidebar.style.top = positionY + 'px';
	}
}

function updatePage() {
    checkVisibleElements();
    positionSidebar();
}

if (sidebarWrapper) {
    buildNavigation();
    window.addEventListener('scroll', updatePage);
}
